// 3rd
import { Model } from '@vuex-orm/core'

// models
import User from './User';

// utils
import {
    API_ENDPOINT_CHANGE_TRACKING,
    API_ENDPOINT_NEW_RETAILER_SUBMISSION,
    API_ENDPOINT_NEW_RETAILER_VALIDATION,
    API_ENDPOINT_POST_AVATAR,
    API_ENDPOINT_POST_CHANGE_COMPANY_DATA,
    API_ENDPOINT_POST_CHANGE_DATA,
    LOADER_CHANGE_TRACKING,
    LOADER_NEW_RETAILER_VALIDATION,
    LOADER_SUBMIT_AVATAR,
    LOADER_SUBMIT_CHANGE_COMPANY_DATA,
    LOADER_SUBMIT_CHANGE_DATA,
    LOADER_RESEND_VERIFICATION,
    API_ENDPOINT_RESEND_VERIFICATION_MAIL,
    LOADER_DELETE_ACCOUNT,
    API_ENDPOINT_DELETE_ACCOUNT,
} from '../utils/constants';
import {
    api,
    authHeaders,
    errorHandler,
} from '../utils/api';
import {
    disableFirebase,
} from '../utils/helper';
import Company from './Company';

export default class Profile extends Model {
    static entity = 'profiles';

    static fields() {
        return {
            id: this.attr(null),
            avatar_url: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            user: this.attr(null),
            private_address_street: this.attr(null),
            private_address_number: this.attr(null),
            private_address_zip: this.attr(null),
            private_address_city: this.attr(null),
            private_address_country: this.attr(null),
            private_phone: this.attr(null),
            business_email: this.attr(null),
            business_phone: this.attr(null),
            employment_type: this.attr(null),
            employment_type_raw: this.attr(null),
            birth_date: this.attr(null),
            company: this.attr(null),
            tracking: this.boolean(false),
        }
    }

    // api calls
    static async postAvatar(form) {
        Profile.store().dispatch('wait/start', LOADER_SUBMIT_AVATAR);
        return await api.post(API_ENDPOINT_POST_AVATAR, form, authHeaders());
    }

    static async setAvatar(avatar) {
        const { data: { profile } } = avatar;

        Profile.update({
            where: profile.id,
            data: {
                avatar_url: profile.avatar_url,
            }
        });
    }

    static async resendVerificationMail() {
        Profile.store().dispatch('wait/start', LOADER_RESEND_VERIFICATION);

        const response = await api.get(API_ENDPOINT_RESEND_VERIFICATION_MAIL, authHeaders()).catch(errorHandler);
        if (!response) return;

        Profile.store().dispatch('wait/end', LOADER_RESEND_VERIFICATION);

        return response;
    }

    static async deleteAccount() {
        Profile.store().dispatch('wait/start', LOADER_DELETE_ACCOUNT);

        const response = await api.post(API_ENDPOINT_DELETE_ACCOUNT, null, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data: { message } } = response;

        Profile.store().dispatch('wait/end', LOADER_DELETE_ACCOUNT);

        return message;
    }

    static async setTracking() {
        Profile.store().dispatch('wait/start', LOADER_CHANGE_TRACKING);

        const response = await api.post(API_ENDPOINT_CHANGE_TRACKING, null, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data: { user_profile } } = response;

        if (user_profile.tracking) {
            // enableFirebase();
        } else {
            disableFirebase();
        }

        Profile.update({
            where: user_profile.id,
            data: {
                ...user_profile,
            }
        });

        Profile.store().dispatch('wait/end', LOADER_CHANGE_TRACKING);
    }

    static async submitChangeCompanyData(form) {
        Profile.store().dispatch('wait/start', LOADER_SUBMIT_CHANGE_COMPANY_DATA);

        const changeData = await api.post(API_ENDPOINT_POST_CHANGE_COMPANY_DATA, form, authHeaders()).catch(errorHandler);

        const { data: { profile } } = changeData;

        User.update({
            where: profile.id,
            data: {
                ...profile,
            }
        });

        Profile.update({
            where: profile.profile.id,
            data: {
                ...profile.profile,

            }
        });

        Company.update({
            where: profile.company.id,
            data: {
                ...profile.company,

            }
        });

        Profile.store().dispatch('wait/end', LOADER_SUBMIT_CHANGE_COMPANY_DATA);

        return changeData;
    }

    static async submitChangeData(form) {
        Profile.store().dispatch('wait/start', LOADER_SUBMIT_CHANGE_DATA);

        const changeData = await api.post(API_ENDPOINT_POST_CHANGE_DATA, form, authHeaders()).catch(errorHandler);

        const { data: { profile } } = changeData;

        User.update({
            where: profile.id,
            data: {
                ...profile,

            }
        });

        Profile.update({
            where: profile.profile.id,
            data: {
                ...profile.profile,

            }
        });

        Profile.store().dispatch('wait/end', LOADER_SUBMIT_CHANGE_DATA);

        return changeData;
    }

    static async validateNewRetailer(form) {
        Profile.store().dispatch('wait/start', LOADER_NEW_RETAILER_VALIDATION);

        const newRetailerValidation = await api.post(API_ENDPOINT_NEW_RETAILER_VALIDATION, form, authHeaders());

        const { data } = newRetailerValidation;

        Profile.store().dispatch('wait/end', LOADER_NEW_RETAILER_VALIDATION);

        return data;
    }

    static async submitNewRetailer(form) {
        const newRetailerSubmission = await api.post(API_ENDPOINT_NEW_RETAILER_SUBMISSION, form, authHeaders());

        const { data } = newRetailerSubmission;

        return data;
    }
}
